var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"feedback-button",attrs:{"id":"pis-footer-btn"},on:{"click":_vm.buttonAction}},[_c('span',[_vm._v(_vm._s(_vm.feedbackContent.LABEL))])])}
var staticRenderFns = []

export { render, staticRenderFns }